import infoBarMessageCreatorsMap from '../utils/infoBarMessageCreatorsMap';
import { action } from 'satcheljs/lib/legacy';
var addInfoBarMessage = action('addInfoBarMessage')(function addInfoBarMessage(viewState, messageId, infoBarMessageViewStateCreator) {
    if (viewState.infoBarIds.indexOf(messageId) == -1) {
        viewState.infoBarIds.push(messageId);
    }
    else {
        // clone infoBarIds to force re-render
        viewState.infoBarIds = viewState.infoBarIds.slice();
    }
    if (infoBarMessageViewStateCreator) {
        if (!infoBarMessageCreatorsMap[viewState.composeId]) {
            infoBarMessageCreatorsMap[viewState.composeId] = {};
        }
        infoBarMessageCreatorsMap[viewState.composeId][messageId] = infoBarMessageViewStateCreator;
    }
});
export default addInfoBarMessage;
//# sourceMappingURL=addInfoBarMessage.js.map